// extracted by mini-css-extract-plugin
export default {"log":"log-module__log___t6Sxw"};